(function () {
  'use strict'

  /**
     * @ngdoc directive
     * @name thismomentGlowModule
     * @module thismoment.glow.component.module
     *
     * @description
     * The base glow module component
     */

  const MODULE_NAME = 'thismoment.glow.component.module'
  const templateUrl = require('./tpl/module.html')

  require('angular')
    .module(MODULE_NAME, [
      require('./module-clc-approval-form'),
      require('./module-embed'),
      require('./module-footer'),
      require('./module-header'),
      require('./module-image-promo'),
      require('./module-navigation'),
      require('./module-playlist'),
      require('./module-multi-playlist'),
      require('./module-contest'),
      require('./module-ugc'),
      require('./module-video-promo')
    ]).component('thismomentGlowModule', {
      templateUrl: templateUrl,
      bindings: {
        displayCart: '<',
        kioskMode: '<',
        module: '<',
        pageTitle: '<',
        path: '<'
      },
      controller: glowModuleController
    })

  glowModuleController.$inject = ['analyticsSDK']
  function glowModuleController (analyticsSDK) {
    const vm = this

    vm.$onInit = glowModuleInit

    function glowModuleInit () {
      vm.trackEvent = analyticsSDK.setupEventTracking({
        'module title': vm.module.get('name'),
        'module type': vm.module.get('type').replace('module_', ''),
        'tm module id': vm.module.get('id')
      })
      vm.trackEvent('Module Viewed', {
        'event trigger': 'loaded module'
      })
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/index.js